export default __webpack_public_path__ + "static/media/example_img_1_3.976edec2.png";